import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header";
import WalletContent from "../../components/Wallet";
import WalletHeaderAction from "../../components/Wallet/HeaderAction";
import { useEffect } from "react";
import { checkBazaarSDK } from "../../redux/action/baseData/baseAction";

const Wallet = () => {
  const hasBazaarSDK = useSelector((state) => state.baseData.bazar_connection);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkBazaarSDK());
  }, []);

  return (
    <>
      <Header title={hasBazaarSDK ? "اعتبار" : "کیف پول"} backBtn={true}>
        <WalletHeaderAction />
      </Header>

      <main className="main-content">
        <WalletContent hasBazaarSDK={hasBazaarSDK} />
      </main>
    </>
  );
};

export default Wallet;
